export const notFoundDict = {
  en: {
    sliderTitle: 'Multimedia & Features',
  },
  ru: {
    sliderTitle: 'Подборка лучших материалов',
  },
  de: {
    sliderTitle: 'Multimedia & Funktionen',
  },
  tr: {
    sliderTitle: 'Multimedya & Özellikler',
  },
  es: {
    sliderTitle: 'Multimedia y funciones',
  },
};
